// @ts-strict-ignore
import type { AggregationSourceData } from './types';
import type { AggregationOption } from './AggregationSelect';
import { AggregationType, TimeframeUnit } from 'flow/store/engine/constants';

// TODO(OAK-1060): Remove INITIAL_AGGREGATION_CONFIG once all sourceData
// fields (scope, timeframe) are persisted in AggregationComponent and
// transformations are complete.
export const INITIAL_AGGREGATION_CONFIG: AggregationSourceData = {
  name: 'Entities',
  description: '',
  aggregationType: AggregationType.COUNT_DISTINCT,
  columnSlug: 'entity_token',
  scope: 'all',
  filters: [],
  timeframeIntervalStart: 0,
  timeframeIntervalEnd: 90,
  timeframeUnit: TimeframeUnit.DAYS,
};

export const AGGREGATION_TYPE_LABELS: Record<AggregationType, string> = {
  [AggregationType.COUNT_DISTINCT]: 'Distinct Count',
  [AggregationType.COUNT]: 'Count',
  [AggregationType.SUM]: 'Sum',
  [AggregationType.AVG]: 'Average',
  [AggregationType.MIN]: 'Min',
  [AggregationType.MAX]: 'Max',
};

export const SCOPE_OPTIONS: AggregationOption[] = [
  { value: 'entity', label: 'For the Entity being evaluated' },
  { value: 'group', label: 'For all Entities in this Group' },
  { value: 'all', label: 'Across all Entities' },
];

export const TIMEFRAME_UNIT_OPTIONS: AggregationOption[] = Object.values(TimeframeUnit).map(
  value => ({ value, label: value }),
);
